var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("title-component"),
      _vm._v(" "),
      _c("b-form", [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 col-sm-12" },
            [
              _c("card-title-component", {
                attrs: { title: _vm.$t("documents.generalDocs.title") }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "card-content" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col general-docs-item" },
                    [
                      _c("input", {
                        ref: "documentInput",
                        staticStyle: { visibility: "hidden" },
                        attrs: { id: "documentInput", type: "file" },
                        on: { change: _vm.fileChosen }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.documents.generalDocs, function(document) {
                        return _c("div", { key: document.id }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function($event) {
                                  _vm.download(document.id, document.name)
                                }
                              }
                            },
                            [
                              _c("icon", { attrs: { name: "file-o" } }),
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(document.name) +
                                  "\n                                "
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function($event) {
                                  _vm.deleteDocument(document.id)
                                }
                              }
                            },
                            [_c("icon", { attrs: { name: "trash-o" } })],
                            1
                          )
                        ])
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "add-link" }, [
                      _c(
                        "a",
                        {
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function($event) {
                              _vm.openInput("document")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.$t("documents.addDocumentButton")) +
                              "\n                                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "b-popover",
                              rawName: "v-b-popover.hover",
                              value: _vm.$t("documents.popover"),
                              expression: "$t('documents.popover')",
                              modifiers: { hover: true }
                            }
                          ],
                          staticClass: "popover-trigger"
                        },
                        [_c("icon", { attrs: { name: "info-circle" } })],
                        1
                      )
                    ])
                  ])
                ])
              ])
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14ac60d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14ac60d5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DocumentsComponent.vue
// module id = null
// module chunks = 